webpackJsonp([1],{

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(30);




new __WEBPACK_IMPORTED_MODULE_2_vue__["default"](__WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_extends___default()({ // eslint-disable-line
  el: '#app'
}, __WEBPACK_IMPORTED_MODULE_1__home_vue___default.a));

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetrend__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hanabi__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hanabi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hanabi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_github_badge__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_github_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_github_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component_theme_default_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_swatches__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_swatches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_swatches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_swatches_dist_vue_swatches_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_swatches_dist_vue_swatches_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_swatches_dist_vue_swatches_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs_themes_vue_tabs_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs_themes_vue_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs_themes_vue_tabs_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Trend: __WEBPACK_IMPORTED_MODULE_0_vuetrend__["a" /* default */], GithubBadge: __WEBPACK_IMPORTED_MODULE_2_vue_github_badge___default.a, VueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a, VSwatches: __WEBPACK_IMPORTED_MODULE_5_vue_swatches___default.a, VueTabs: __WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs__["VueTabs"], VTab: __WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs__["VTab"] },

  data: function data() {
    return {
      radius: 8,
      padding: 8,
      width: 1,
      gradientDirection: 'top',
      color1: '#6fa8dc',
      color2: '#42b983',
      color3: '#2c3e50',
      linecap: 'butt'
    };
  },

  computed: {
    code: function code() {
      return __WEBPACK_IMPORTED_MODULE_1_hanabi___default()('<trend\n  :data="[0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0]"\n  :gradientDirection="' + this.gradientDirection + '"\n  :gradient="[\'' + this.color1 + '\', \'' + this.color2 + '\', \'' + this.color3 + '\']"\n  :padding="' + this.padding + '"\n  :radius="' + this.radius + '"\n  :stroke-width="' + this.width + '"\n  :stroke-linecap="' + this.linecap + '"\n  auto-draw\n  smooth>\n</trend>');
    }
  },

  created: function created() {
    this.data = [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0];
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['gradient', 'gradientDirection', 'id'],

  render: function render(h) {
    var gradient = this.gradient,
        gradientDirection = this.gradientDirection,
        id = this.id;

    var len = gradient.length - 1 || 1;
    var stops = gradient.slice().reverse().map(function (color, index) {
      return h('stop', {
        attrs: {
          offset: index / len,
          'stop-color': color
        }
      });
    });

    return h('defs', [h('linearGradient', {
      attrs: {
        id: id,
        /*
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 1
        */
        x1: +(gradientDirection === 'left'),
        y1: +(gradientDirection === 'top'),
        x2: +(gradientDirection === 'right'),
        y2: +(gradientDirection === 'bottom')
      }
    }, stops)]);
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_path__ = __webpack_require__(38);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['smooth', 'data', 'boundary', 'radius', 'id', 'max', 'min'],

  render: function render(h) {
    var data = this.data,
        smooth = this.smooth,
        boundary = this.boundary,
        radius = this.radius,
        id = this.id,
        max = this.max,
        min = this.min;

    var points = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_path__["a" /* genPoints */])(data, boundary, { max: max, min: min });
    var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_path__["b" /* genPath */])(points, smooth ? radius : 0);

    return h('path', {
      attrs: { d: d, fill: 'none', stroke: 'url(#' + id + ')' }
    });
  }
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gradient__ = __webpack_require__(34);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Trend',

  props: {
    data: {
      type: Array,
      required: true
    },
    autoDraw: Boolean,
    autoDrawDuration: {
      type: Number,
      default: 2000
    },
    autoDrawEasing: {
      type: String,
      default: 'ease'
    },
    gradient: {
      type: Array,
      default: function _default() {
        return ['#000'];
      }
    },
    gradientDirection: {
      type: String,
      default: 'top'
    },
    max: {
      type: Number,
      default: -Infinity
    },
    min: {
      type: Number,
      default: Infinity
    },
    height: Number,
    width: Number,
    padding: {
      type: Number,
      default: 8
    },
    radius: {
      type: Number,
      default: 10
    },
    smooth: Boolean
  },

  watch: {
    data: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        this.$nextTick(function () {
          if (_this.$isServer || !_this.$refs.path || !_this.autoDraw) {
            return;
          }

          var path = _this.$refs.path.$el;
          var length = path.getTotalLength();

          path.style.transition = 'none';
          path.style.strokeDasharray = length + ' ' + length;
          path.style.strokeDashoffset = Math.abs(length - (_this.lastLength || 0));
          path.getBoundingClientRect();
          path.style.transition = 'stroke-dashoffset ' + _this.autoDrawDuration + 'ms ' + _this.autoDrawEasing;
          path.style.strokeDashoffset = 0;
          _this.lastLength = length;
        });
      }
    }
  },

  render: function render(h) {
    if (!this.data || this.data.length < 2) return;
    var width = this.width,
        height = this.height,
        padding = this.padding;

    var viewWidth = width || 300;
    var viewHeight = height || 75;
    var boundary = {
      minX: padding,
      minY: padding,
      maxX: viewWidth - padding,
      maxY: viewHeight - padding
    };
    var props = this.$props;

    props.boundary = boundary;
    props.id = 'vue-trend-' + this._uid;
    return h('svg', {
      attrs: {
        width: width || '100%',
        height: height || '25%',
        viewBox: '0 0 ' + viewWidth + ' ' + viewHeight
      }
    }, [h(__WEBPACK_IMPORTED_MODULE_1__gradient__["a" /* default */], {
      props: props
    }), h(__WEBPACK_IMPORTED_MODULE_0__path__["a" /* default */], {
      props: props,
      ref: 'path'
    })]);
  }
});

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkCollinear;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDistance;
/* harmony export (immutable) */ __webpack_exports__["c"] = moveTo;
function int(value) {
  return parseInt(value, 10);
}

/**
 * https://en.wikipedia.org/wiki/Collinearity
 * x=(x1+x2)/2
 * y=(y1+y2)/2
 */
function checkCollinear(p0, p1, p2) {
  return int(p0.x + p2.x) === int(2 * p1.x) && int(p0.y + p2.y) === int(2 * p1.y);
}

function getDistance(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

function moveTo(to, from, radius) {
  var vector = { x: to.x - from.x, y: to.y - from.y };
  var length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
  var unitVector = { x: vector.x / length, y: vector.y / length };

  return {
    x: from.x + unitVector.x * radius,
    y: from.y + unitVector.y * radius
  };
}

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = genPoints;
/* harmony export (immutable) */ __webpack_exports__["b"] = genPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(37);



/**
 *  Calculate the coordinate
 * @param  {number[]|object[]}  arr
 * @param  {object}             boundary
 * @return {object[]}
 */
function genPoints(arr, _ref, _ref2) {
  var minX = _ref.minX,
      minY = _ref.minY,
      maxX = _ref.maxX,
      maxY = _ref.maxY;
  var max = _ref2.max,
      min = _ref2.min;

  arr = arr.map(function (item) {
    return typeof item === 'number' ? item : item.value;
  });
  var minValue = Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_toConsumableArray___default()(arr).concat([min])) - 0.001;
  var gridX = (maxX - minX) / (arr.length - 1);
  var gridY = (maxY - minY) / (Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0__Users_cinwell_gh_vue_trend_node_modules_babel_runtime_helpers_toConsumableArray___default()(arr).concat([max])) + 0.001 - minValue);

  return arr.map(function (value, index) {
    return {
      x: index * gridX + minX,
      y: maxY - (value - minValue) * gridY + +(index === arr.length - 1) * 0.00001 - +(index === 0) * 0.00001
    };
  });
}

/**
 * From https://github.com/unsplash/react-trend/blob/master/src/helpers/DOM.helpers.js#L18
 */
function genPath(points, radius) {
  var start = points.shift();

  return 'M' + start.x + ' ' + start.y + points.map(function (point, index) {
    var next = points[index + 1];
    var prev = points[index - 1] || start;
    var isCollinear = next && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* checkCollinear */])(next, point, prev);

    if (!next || isCollinear) {
      return 'L' + point.x + ' ' + point.y;
    }

    var threshold = Math.min(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* getDistance */])(prev, point), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* getDistance */])(next, point));
    var isTooCloseForRadius = threshold / 2 < radius;
    var radiusForPoint = isTooCloseForRadius ? threshold / 2 : radius;

    var before = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* moveTo */])(prev, point, radiusForPoint);
    var after = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* moveTo */])(next, point, radiusForPoint);

    return 'L' + before.x + ' ' + before.y + 'S' + point.x + ' ' + point.y + ' ' + after.x + ' ' + after.y;
  }).join('');
}

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trend__ = __webpack_require__(36);


__WEBPACK_IMPORTED_MODULE_0__components_trend__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_trend__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_trend__["a" /* default */]);
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(__WEBPACK_IMPORTED_MODULE_0__components_trend__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_trend__["a" /* default */]);

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(75)

var Component = __webpack_require__(81)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 82:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('github-badge', {
    attrs: {
      "slug": "QingWei-Li/vue-trend"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Vue Trend")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('trend', {
    attrs: {
      "data": _vm.data,
      "gradient": [_vm.color1, _vm.color2, _vm.color3],
      "padding": _vm.padding,
      "radius": _vm.radius,
      "stroke-width": _vm.width,
      "stroke-linecap": _vm.linecap,
      "gradientDirection": _vm.gradientDirection,
      "auto-draw": "",
      "smooth": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "playground"
  }, [_c('vue-tabs', [_c('v-tab', {
    attrs: {
      "title": "Configure"
    }
  }, [_c('div', {
    staticClass: "settings-container"
  }, [_c('div', {
    staticClass: "settings-column"
  }, [_c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Gradient direction")]), _vm._v(" "), _c('group', {
    staticClass: "inline-radio"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradientDirection),
      expression: "gradientDirection"
    }],
    attrs: {
      "type": "radio",
      "id": "gd-top",
      "value": "top"
    },
    domProps: {
      "checked": _vm._q(_vm.gradientDirection, "top")
    },
    on: {
      "change": function($event) {
        _vm.gradientDirection = "top"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gd-top"
    }
  }, [_vm._v("top")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradientDirection),
      expression: "gradientDirection"
    }],
    attrs: {
      "type": "radio",
      "id": "gd-bottom",
      "value": "bottom"
    },
    domProps: {
      "checked": _vm._q(_vm.gradientDirection, "bottom")
    },
    on: {
      "change": function($event) {
        _vm.gradientDirection = "bottom"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gd-bottom"
    }
  }, [_vm._v("bottom")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradientDirection),
      expression: "gradientDirection"
    }],
    attrs: {
      "type": "radio",
      "id": "gd-left",
      "value": "left"
    },
    domProps: {
      "checked": _vm._q(_vm.gradientDirection, "left")
    },
    on: {
      "change": function($event) {
        _vm.gradientDirection = "left"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gd-left"
    }
  }, [_vm._v("left")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradientDirection),
      expression: "gradientDirection"
    }],
    attrs: {
      "type": "radio",
      "id": "gd-right",
      "value": "right"
    },
    domProps: {
      "checked": _vm._q(_vm.gradientDirection, "right")
    },
    on: {
      "change": function($event) {
        _vm.gradientDirection = "right"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gd-right"
    }
  }, [_vm._v("right")])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Gradient first color")]), _vm._v(" "), _c('v-swatches', {
    attrs: {
      "swatch-size": 18,
      "background-color": "#f7f7f7",
      "swatches": ['#b8f2e6', '#6fa8dc', '#42b983', '#3a86ff', '#2c3e50', '#000000', '#ffe74c', '#ffbe88', '#ff93df', '#f94144', '#d6d6d6'],
      "inline": ""
    },
    model: {
      value: (_vm.color1),
      callback: function($$v) {
        _vm.color1 = $$v
      },
      expression: "color1"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Gradient second color")]), _vm._v(" "), _c('v-swatches', {
    attrs: {
      "swatch-size": 18,
      "background-color": "#f7f7f7",
      "swatches": ['#b8f2e6', '#6fa8dc', '#42b983', '#3a86ff', '#2c3e50', '#000000', '#ffe74c', '#ffbe88', '#ff93df', '#f94144', '#d6d6d6'],
      "inline": ""
    },
    model: {
      value: (_vm.color2),
      callback: function($$v) {
        _vm.color2 = $$v
      },
      expression: "color2"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Gradient third color")]), _vm._v(" "), _c('v-swatches', {
    attrs: {
      "swatch-size": 18,
      "background-color": "#f7f7f7",
      "swatches": ['#b8f2e6', '#6fa8dc', '#42b983', '#3a86ff', '#2c3e50', '#000000', '#ffe74c', '#ffbe88', '#ff93df', '#f94144', '#d6d6d6'],
      "inline": ""
    },
    model: {
      value: (_vm.color3),
      callback: function($$v) {
        _vm.color3 = $$v
      },
      expression: "color3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "settings-column"
  }, [_c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Width")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 12,
      "interval": 0.1
    },
    model: {
      value: (_vm.width),
      callback: function($$v) {
        _vm.width = $$v
      },
      expression: "width"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Padding")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 12,
      "interval": 0.1
    },
    model: {
      value: (_vm.padding),
      callback: function($$v) {
        _vm.padding = $$v
      },
      expression: "padding"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Radius")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 12,
      "interval": 0.1
    },
    model: {
      value: (_vm.radius),
      callback: function($$v) {
        _vm.radius = $$v
      },
      expression: "radius"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-label"
  }, [_vm._v("Linecap")]), _vm._v(" "), _c('group', {
    staticClass: "inline-radio"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linecap),
      expression: "linecap"
    }],
    attrs: {
      "type": "radio",
      "id": "lc-butt",
      "value": "butt"
    },
    domProps: {
      "checked": _vm._q(_vm.linecap, "butt")
    },
    on: {
      "change": function($event) {
        _vm.linecap = "butt"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lc-butt"
    }
  }, [_vm._v("butt")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linecap),
      expression: "linecap"
    }],
    attrs: {
      "type": "radio",
      "id": "lc-round",
      "value": "round"
    },
    domProps: {
      "checked": _vm._q(_vm.linecap, "round")
    },
    on: {
      "change": function($event) {
        _vm.linecap = "round"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lc-round"
    }
  }, [_vm._v("round")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linecap),
      expression: "linecap"
    }],
    attrs: {
      "type": "radio",
      "id": "lc-square",
      "value": "square"
    },
    domProps: {
      "checked": _vm._q(_vm.linecap, "square")
    },
    on: {
      "change": function($event) {
        _vm.linecap = "square"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lc-square"
    }
  }, [_vm._v("square")])])])], 1)])])]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "title": "Code"
    }
  }, [_c('pre', {
    staticClass: "code-wrap"
  }, [_c('code', {
    staticClass: "code",
    domProps: {
      "innerHTML": _vm._s(_vm.code)
    }
  })])])], 1)], 1), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "headline"
  }, [_vm._v(" Simple, elegant spark lines for Vue.js "), _c('a', {
    attrs: {
      "href": "https://jsfiddle.net/nyh18bLq/"
    }
  }, [_vm._v("Live Demo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._v("Released under the "), _c('a', {
    attrs: {
      "href": "//github.com/QingWei-Li/vue-trend/blob/master/LICENSE"
    }
  }, [_vm._v("MIT")]), _vm._v(" license. "), _c('a', {
    attrs: {
      "href": "//github.com/QingWei-Li/vue-trend"
    }
  }, [_vm._v("View source.")])])
}]}

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(31);


/***/ })

},[86]);


// WEBPACK FOOTER //
// client.3021d66a.js